import React from 'react';

import billToPages from './billTo';
import payerPages from './payer';
import shipToPages from './shipTo';
import soldToPages from './soldTo';

// ----------------- Types -----------------
interface Field {
  key: string;
  required?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type GenericComponent = React.ComponentType<any>;

interface Card {
  key: string;
  Component: GenericComponent;
  fields?: Field[];
  fieldWrapper?: string;
  sameAsFields?: string[];
  hideSameAs?: boolean;
}

interface Page {
  route: string;
  Component: GenericComponent;
  cards?: Card[];
  accordions?: unknown[];
  validateFinancials?: boolean;
}

// ----------------- TEMPLATE MAP -----------------
export const templateMap: Record<
  'bill_to' | 'payer' | 'ship_to' | 'sold_to',
  { pages: Page[] }
> = {
  bill_to: {
    pages: billToPages
  },
  payer: {
    pages: payerPages
  },
  ship_to: {
    pages: shipToPages
  },
  sold_to: {
    pages: soldToPages
  }
};